export default __webpack_public_path__ + "static/bell_w.3a908783c2039b63e765858f68a9e7bc.png";